import { TurnMargins } from "@pdfking/filling-flex"
import type { Distance, SpatialRectangle } from "@pdfking/math"
import { AddMargins } from "@pdfking/math"

import type { ImpositionPage } from "#internal"

/** The room a page takes on the sheet: the page and what it keeps clear
 * around it, that padding turned with the page. */
export const PageCell = (page: ImpositionPage): SpatialRectangle<Distance> =>
  AddMargins(page.position, TurnMargins(page.padding, page.rotation))
